
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData, getDateAndTime, handleDateChange } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const UserLogReport = ({ menuText }) => {
    //--Inital State--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)

    const [formData, setFormData] = useState({
        logDateFrom: getDateAndTime().date,
        logDateTo: getDateAndTime().date,
        logType: '',
        formName: '',
        userCode:'',
    })

    //--Handle Clear Function--//
    const handleClear = () => {
        setFormData({
            logDateFrom: getDateAndTime().date,
            logDateTo: getDateAndTime().date,
            logType: '',
            formName: '',
            userCode: '',
        });
        filterData.SearchText = ''
        getUserLogReportData()
        inputrefs.current['txtLogDateFrom'].focus();
    };

  
    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

   

    //--Grid Data Fetch Function--//
    const getUserLogReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...formData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/User/UserLogReport', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getUserLogReportData(value);
    };



    useEffect(() => {
        getUserLogReportData();
    }, [sortConfig])

    useEffect(() => {
        inputrefs.current['txtLogDateFrom'].focus();
        document.title = 'User Log Report'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('User Log Report')}</h6>
                </div>

                <div className='card-body row'>

                    <div className='row'>
                        <DateBox
                            inputrefs={inputrefs}
                            label="Log Date From"
                            placeholder="Log Date From"
                            id='txtLogDateFrom'
                            preventOpenOnFocus={true}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtLogDateTo'].focus()
                                };
                            }}

                            selected={formData.logDateFrom === '' ? '' : new Date(formData.logDateFrom)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'logDateFrom')}
                        />

                        <DateBox
                            inputrefs={inputrefs}
                            label="Log Date To"
                            placeholder="Log Date To"
                            id='txtLogDateTo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtLogType'].focus()
                                };
                            }}

                            selected={formData.logDateTo === '' ? '' : new Date(formData.logDateTo)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'logDateTo')}
                        />
                        <SelectInputBox
                            id="txtLogType"
                            value={formData.logType}
                            label='Log Type'
                            onChange={(e) => setFormData({ ...formData, logType: e.target.value, })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtFormName'].focus()
                                }
                            }}
                        >
                            <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                            <option value="INSERT">INSERT</option>
                            <option value="UPDATE">UPDATE</option>
                            <option value="DELETE">DELETE</option>
                        </SelectInputBox>

                        <InputBox
                            label='Form Name'
                            PlaceHolderText='Form Name'
                            inputrefs={inputrefs}
                            id='txtFormName'
                            value={formData.formName}
                            maxLength='100'
                            onChange={(e) => {
                                setFormData({ ...formData, formName: e.target.value })
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtUser'].focus();
                                }
                            }}
                        />

                        <AutoCompleteBoxNew
                            label='User'
                            placeholder='User'
                            value={formData.userCode ? formData.userCode : ''}
                            onChange={
                                (event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, userCode: newInputValue, })
                                    }
                                }}
                            maxLength='50'

                            inputrefs={inputrefs}
                            id='txtUser'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['btnSub'].focus() };
                            }}
                            autocompleteType='GetUserCode'
                        />
                      
                    </div>

                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id={'btnSub'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getUserLogReportData}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/User/UserLogReport`, formData, 'User Log Report')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>

                </div>

            </div>
            <Table
              
                PageName={'UserLogReport'}
                loading={loading}
                handleFilter={() => {
                    getUserLogReportData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                Filter={false}
                onlyFilterPage={true}
                filterData={filterData}
                tableData={result}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

        </>
    )
}

export default UserLogReport;